import { call, put, takeLatest } from 'redux-saga/effects';

import { actions } from '../../utils/constants';
import { fetchUserData, fetchUserDataFromCognito, goLogout, postLogin, withRetry, fetchUserDataName } from '../../utils/common-functions';
import history from '../../history';
import routes from '../../utils/routes';
import CredentialsHelper from '../../utils/credentials-helper';

function* doLogout() {
    CredentialsHelper.clear();
    yield call(goLogout);
}

function* tokenFromCode({ payload : { code, isExternal } }) {
    const KASP_MAX_ATTEMPT = 20;
    let kaspAttempt = 0;

    while (true) {
        let kaspError = false;
        kaspAttempt++;

        if (kaspAttempt > 1) {
            // eslint-disable-next-line no-console
            console.log(`attempt ${kaspAttempt} with kaspersky injected script`);
        }

        try {
            const { data: loginInfo } = yield call(postLogin, {
                grant_type: 'authorization_code',
                code,
                redirect_uri: isExternal ? 'none' : window.location.origin + '/',
            });

            yield call(CredentialsHelper.update, loginInfo.access_token, loginInfo.refresh_token);
            yield call(history.push, routes.HOME);

            // success
            return;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(`tokenFromCode error: ${e.message}`);

            if (e.message === 'ns.GetCommandSrc is not a function') {
                kaspError = true;
            }
        }

        if (kaspError === true && kaspAttempt < KASP_MAX_ATTEMPT) {
            // eslint-disable-next-line no-console
            console.log('wait for 1 seconds for kaspersky injected script has been loaded');
            yield new Promise(resolve => setTimeout(resolve, 1000));
        } else {
            yield call(doLogout);

            // failed
            return;
        }
    }
}

export function* userInformation() {
    try {
        const userInfoRespose = yield call(withRetry(fetchUserData));
        const userInfoResposeLogin = yield call(withRetry(fetchUserDataName));

        yield put({ type: actions.USER_INFO_FETCHED, payload: { ...userInfoRespose.data, nickname: userInfoResposeLogin.data.nickname } });
        yield put({ type: actions.USER_ID_FETCHED, payload: { id: userInfoResposeLogin.data.id } } );
    } catch (e) {
        if (e.response.status === 404 ) {
            yield call(checkUserFromCognito);
        } else {
            yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Seu perfil não pôde ser carregado. Tente recarregar a página' } });
        }
    }
}

export function* checkUserFromCognito() {
    try {
        const userInfoRespose = yield call(withRetry(fetchUserDataFromCognito));
        yield put({ type: actions.USER_INFO_FETCHED, payload: userInfoRespose.data });
    } catch (error) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Seu perfil não pôde ser carregado. Tente recarregar a página' } });
    }
}

function* doExternalLogin({ payload }) {
    try {
        yield put({ type: actions.SET_EXTERNAL_LOGIN, payload: true });
        yield put({ type: actions.LOGIN_FROM_CODE, payload: { code: payload, isExternal: true } });
    } catch (error) {
        yield put({ type: actions.REQUEST_ERROR, payload: { error, message: 'Não foi possivel fazer o login externo' } });
    }
}

export default function* login() {
    yield takeLatest(actions.LOGOUT_DO, doLogout);
    yield takeLatest(actions.LOGIN_FROM_CODE, tokenFromCode);
    yield takeLatest(actions.EXTERNAL_LOGIN, doExternalLogin);
}



// WEBPACK FOOTER //
// ./src/components/login/login.saga.js